var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBreadcrumb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34143",
    "data-name": "Group 34143",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12827",
    "data-name": "Group 12827",
    transform: "translate(15.386 25.229) rotate(-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "line",
    width: 9.655,
    height: 1.931,
    rx: 0.965,
    transform: "translate(1.365 0.035) rotate(45)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "line-2",
    "data-name": "line",
    width: 9.655,
    height: 1.931,
    rx: 0.966,
    transform: "translate(5.468 6.827) rotate(-45)",
    fill: "#353841"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6163",
    "data-name": "Rectangle 6163",
    width: 38,
    height: 38,
    transform: "translate(0)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBreadcrumb);
export default __webpack_public_path__ + "static/media/arrow-breadcrumb.969d3cbc43fcb6602e446c5178357f05.svg";
export { ForwardRef as ReactComponent };